import React from 'react';
import styled from 'styled-components';
import theme from 'styles/theme';
import { Row, Text } from 'components/pages/market/home/MarketItem';
import useScrollDirection from 'hooks/common/useScrollDirection';

const MarketTabBar = ({ tabIndex, handleTabIndex }) => {
   const HEADER_HEIGHT = 50;
   const scrollDirection = useScrollDirection();
   const isShowTabBar = scrollDirection === 'up' || scrollDirection === null;

   const tabBarStyle = {
      position: scrollDirection === 'up' ? 'sticky' : 'relative',
      top: scrollDirection === 'up' ? `${HEADER_HEIGHT}px` : '0px',
      height: isShowTabBar ? 'auto' : '0px',
   };

   return (
      <MarketTabBarWrap style={tabBarStyle}>
         {MARKET_TABS.map((tab, idx) => {
            return (
               <Tab
                  key={tab.name}
                  onClick={() => handleTabIndex(idx)}
                  isSelected={idx === tabIndex}
               >
                  <Text>{tab.name}</Text>
               </Tab>
            );
         })}
      </MarketTabBarWrap>
   );
};

export default MarketTabBar;

export const MARKET_TABS = [
   {
      name: '전체',
   },
   {
      name: '고속터미널',
   },
   {
      name: '양재',
   },
];

const MarketTabBarWrap = styled(Row)`
   border-bottom: 1px solid ${theme.color.gray100};
   background-color: ${theme.color.white};
   z-index: 99;
`;

const Tab = styled.div`
   user-select: none;
   cursor: pointer;
   width: 100%;
   color: ${({ isSelected }) => (isSelected ? theme.color.orange : theme.color.black)};
   font-weight: ${({ isSelected }) => (isSelected ? 700 : 400)};
   font-size: 16px;
   line-height: 24px;
   text-align: center;

   ${Text} {
      margin: 0 auto;
      width: fit-content;
      border-bottom: 2px solid
         ${({ isSelected }) => (isSelected ? theme.color.orange : theme.color.white)};
      padding: 8px 0px;
   }
`;
